export class ReplaceLongStayRateCommand {
	id: number;
	/** Null with rate = "No long stay", allowed only on a level row. */
	nightThreshold: number | null;
	rate: number | null;
}
